export class OverviewDto {

  public readonly invoiceDraftCount: number | undefined;
  public readonly invoiceDraftSumNetAmount: number | undefined;
  public readonly invoiceOrderCount: number | undefined;
  public readonly invoiceOrderSumNetAmount: number | undefined;
  public readonly invoiceUnpaidCount: number | undefined;
  public readonly invoiceUnpaidAmount: number | undefined;
  public readonly invoiceCurrentYear: number | undefined;
  public readonly invoiceCurrentYearCount: number | undefined;
  public readonly invoiceCurrentYearSumNetAmount: number | undefined;
  public readonly invoiceLastYear: number | undefined;
  public readonly invoiceLastYearCount: number | undefined;
  public readonly invoiceLastYearSumNetAmount: number | undefined;
  public readonly invoiceCurrentMonthCount: number | undefined;
  public readonly invoiceCurrentMonthSumNetAmount: number | undefined;
  public readonly invoiceLastMonthCount: number | undefined;
  public readonly invoiceLastMonthSumNetAmount: number | undefined;
  public readonly cancellationCurrentYearCount: number | undefined;
  public readonly cancellationCurrentYearSumNetAmount: number | undefined;
  public readonly cancellationCurrentMonthCount: number | undefined;
  public readonly cancellationCurrentMonthSumNetAmount: number | undefined;
  public readonly cancellationLastMonthCount: number | undefined;
  public readonly cancellationLastMonthSumNetAmount: number | undefined;
  public readonly costEstimateCurrentYearCount: number | undefined;
  public readonly costEstimateCurrentYearSumNetAmount: number | undefined;
  public readonly costEstimateCurrentMonthCount: number | undefined;
  public readonly costEstimateCurrentMonthSumNetAmount: number | undefined;
  public readonly costEstimateLastMonthCount: number | undefined;
  public readonly costEstimateLastMonthSumNetAmount: number | undefined;
  public readonly contactCount: number | undefined;
  public readonly contactDebtorCount: number | undefined;
  public readonly contactCreditorCount: number | undefined;
  public readonly contactVehicleCount: number | undefined;
  public readonly contactVehicleInspectionCount: number | undefined;
  public readonly contactVehicleTireChangeCount: number | undefined;
  public readonly articleCount: number | undefined;
  public readonly mediaCount: number | undefined;
  public readonly mediaSize: number | undefined;
  public readonly receiptCount: number | undefined;
  public readonly receiptSumNetAmount: number | undefined;
  public readonly receiptUnreviewedCount: number | undefined;
  public readonly receiptUnreviewedSumNetAmount: number | undefined;
  public readonly receiptUnpaidCount: number | undefined;
  public readonly receiptUnpaidAmount: number | undefined;
  public readonly assignedOrgCount: number | undefined;
  public readonly deathCount: number | undefined;
  public readonly deathCurrentYear: number | undefined;
  public readonly deathCurrentYearCount: number | undefined;
  public readonly deathLastYear: number | undefined;
  public readonly deathLastYearCount: number | undefined;
  public readonly sheetCount: number | undefined;

  constructor(init?: Partial<OverviewDto>) {
    Object.assign(this, init);
  }
}
